import { render, staticRenderFns } from "./TokenTransTable.vue?vue&type=template&id=d4408526&"
import script from "./TokenTransTable.vue?vue&type=script&lang=js&"
export * from "./TokenTransTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports